import { ASSET_PATHS } from '../../utils/assetPath';

import './UploadIcon.css';

interface UploadIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * UploadIcon component
 *
 * Displays an upload icon using the SVG from the public folder.
 * Used primarily for file upload actions throughout the application.
 *
 * @example
 * <UploadIcon />
 * <UploadIcon size={32} ariaLabel="Upload file" />
 */
function UploadIcon({ className = '', size = 24, ariaLabel = 'Upload' }: UploadIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`upload-icon ${className}`}
      height={size}
      src={ASSET_PATHS.FILE_UPLOAD_ICON}
      width={size}
    />
  );
}

export default UploadIcon;
